import React from "react"
import { graphql } from "gatsby"
import { Link } from "gatsby"
import { Helmet } from "react-helmet"
import Img from "gatsby-image"
import ProjectList from "../components/ProjectList";
import ArticleList from "../components/ArticleList";
// import YoutubeVideo from "../components/YoutubeVideo";
import Markdown from "../components/Markdown"
import config from "../config/config";
// import * as PropTypes from "prop-types"

import style from "./index.module.css";

// const propTypes = {
//   data: PropTypes.object.isRequired,
// }

const IndexPage = ({ data }) => {
  const pageContent = data.page;
  // const video = (pageContent.videoActive && pageContent.video) ? pageContent.video : false;
  const introImage = true;
  const dateNow = new Date();
  const dateChallengeOpen = new Date(config.challengeOpen);
  const dateChallengeClosed = new Date(config.challengeClosed);
  const dateVotingOpen = new Date(config.votingOpen);
  const dateVotingClosed = new Date(config.votingClosed);
  const challengeActive = (dateNow > dateChallengeOpen) && (dateNow < dateChallengeClosed);
  const votingActive = (dateNow > dateVotingOpen) && (dateNow < dateVotingClosed);
  return (
    <div>
      <Helmet>
        <title>{pageContent.title}</title>
      </Helmet>
      {(introImage && challengeActive) &&
        <div className={style.imageContainer}>
          <Link to="/challenge/"><Img className={style.image} fluid={pageContent.introImage.fluid} alt={pageContent.introImage.title} title={pageContent.introImage.title}  /></Link>
        </div>
      }

      {/*
      <section className={style.background}>
        <div className={style.text}>
          {pageContent.introTitle &&
            <h1>{pageContent.introTitle}</h1>
          }
          {pageContent.introText.introText &&
            <Markdown source={pageContent.introText.introText} softBreak="br" className={style.intro} />
          }
          {challengeActive &&
            <div className={style.buttonContainer}>
              <Link className={style.button} to="/challenge/">Doe mee</Link>
            </div>
          }
          {video &&
            <div className={style.video}>
              <YoutubeVideo videoUrl={video} />
            </div>
          }
        </div>
      </section>
      */}

      {/*challengeActive &&
        <section className={style.backgroundAlt}>
          <div className={style.text}>
            {pageContent.planTitle &&
              <h1>{pageContent.planTitle}</h1>
            }
            {pageContent.planText.planText &&
              <Markdown source={pageContent.planText.planText} softBreak="br" className={style.intro} />
            }
            <div className={style.buttonContainer}>
              <Link className={style.button} to="/challenge/">Stuur je plan in</Link>
            </div>
          </div>
        </section>
      */}

      {votingActive &&
        <section className={style.backgroundAlt}>
          <div className={style.text}>
            {pageContent.votingTitle &&
              <h1>{pageContent.votingTitle}</h1>
            }
            {pageContent.votingText &&
              <Markdown source={pageContent.votingText.votingText} softBreak="br" className={style.intro} />
            }
            {pageContent.votingButton &&
              <div className={style.buttonContainer}>
                <Link className={style.button} to="/stemmen">{pageContent.votingButton}</Link>
              </div>
            }
          </div>
        </section>
      }

      {pageContent.prijswinnaarsActive &&
        <div>
          <section className={style.background}>
            {pageContent.prijswinnaarsTitel &&
              <h1>{pageContent.prijswinnaarsTitel}</h1>
            }
            {pageContent.prijswinnaarsImage &&
              <div className={style.imageContainer}>
                <Link to="/prijswinnaars/#2019">
                  <img className={style.image} src={pageContent.prijswinnaarsImage.sizes.src} alt="Prijswinnaars" />
                </Link>
              </div>
            }
            <div className={style.text}>
              {pageContent.prijswinnaarsTekst &&
                <Markdown source={pageContent.prijswinnaarsTekst.prijswinnaarsTekst} softBreak="br" className={style.intro} />
              }
            </div>
          </section>
        </div>
      }

      <section className={style.background}>
        <div className={style.text}>
          {pageContent.inspirationTitle &&
            <h1>{pageContent.inspirationTitle}</h1>
          }
          {pageContent.inspirationText.inspirationText &&
            <Markdown source={pageContent.inspirationText.inspirationText} softBreak="br" className={style.intro} />
          }
        </div>
      </section>
      {pageContent.inspirationProjects &&
        <section className={style.list}>
          <ProjectList projects={pageContent.inspirationProjects} />
          <Link className={style.buttonLarge} to="/inspiratie/">Meer inspiratie</Link>
        </section>
      }


      <section className={style.background}>
        <div className={style.text}>
          {pageContent.updateTitel &&
            <h1>{pageContent.updateTitel}</h1>
          }
          {pageContent.updateTekst.updateTekst &&
            <Markdown source={pageContent.updateTekst.updateTekst} softBreak="br" className={style.intro} />
          }
        </div>
      </section>
      {pageContent.nieuwsartikelen &&
        <section className={style.list}>
          <ArticleList articles={pageContent.nieuwsartikelen} />
          <Link className={style.buttonLarge} to="/update/">Meer uit de Bijprater</Link>
        </section>
      }

    </div>
  )
}

export default IndexPage

export const query = graphql`
  query {
    page: contentfulHomePagina {
      id
      title
      video
      videoActive
      metaDescription {
        metaDescription
      }
      introTitle
      introText {
        introText
      }
      introImage: image {
        fluid(maxWidth: 3000) {
          sizes
          src
          srcSet
          srcWebp
          srcSetWebp
          aspectRatio
        }
      }
      planTitle
      planText {
        planText
      }
      votingTitle
      votingText {
        votingText
      }
      votingButton
      prijswinnaarsActive
      prijswinnaarsTitel
      prijswinnaarsTekst {
        prijswinnaarsTekst
      }
      prijswinnaarsImage {
        sizes(maxWidth: 1500, quality: 80) {
          sizes
          src
          srcSet
          srcWebp
          srcSetWebp
        }
      }
      inspirationTitle
      inspirationText {
        inspirationText
      }
      inspirationProjects {
        id
        title
        slug
        quote
        image {
          fluid(maxWidth: 600) {
            sizes
            src
            srcSet
            srcWebp
            srcSetWebp
            aspectRatio
          }
        }
      }
      updateTitel
      updateTekst {
        updateTekst
      }
      nieuwsartikelen {
        title
        slug
        category
        date
        id
        description {
          description
        }
        imageOverview {
          fluid(maxWidth: 600) {
            sizes
            src
            srcSet
            srcWebp
            srcSetWebp
            aspectRatio
          }
        }
      }
    }
  }
`